export var UrlUtil;
(function (UrlUtil) {
    function createWebUrl(path = "", paramMap = null) {
        const url = createUrl(path, paramMap, '/#');
        return url;
    }
    UrlUtil.createWebUrl = createWebUrl;
    function createFullWebUrl(path = "", paramMap = null) {
        const url = createWebUrl(path, paramMap);
        return location.origin + url;
    }
    UrlUtil.createFullWebUrl = createFullWebUrl;
    /**
     * Api の URL を作成
     * @param path
     * @param paramMap
     */
    function createApiUrl(path = "", paramMap = null) {
        const url = createUrl(path, paramMap, '/api');
        // if (path.indexOf('/') !== 0) {
        //     path = '/' + path;
        // }
        // let url = "/api" + path;
        // if (paramMap !== null) {
        //     if (Object.keys(paramMap).length > 0) {
        //         let paramUrl = '';
        //         for (const key in paramMap) {
        //             if (paramUrl === '') {
        //                 paramUrl = '?';
        //             } else {
        //                 paramUrl += '&';
        //             }
        //             const value = paramMap[key];
        //             if (value === undefined) {
        //                 paramUrl += key;
        //             } else {
        //                 // エンコードを行ってから設定する
        //                 const encodeValue = encodeURIComponent(value);
        //                 paramUrl += `${key}=${encodeValue}`;
        //             }
        //         }
        //         url += paramUrl;
        //     }
        // }
        return url;
    }
    UrlUtil.createApiUrl = createApiUrl;
    function createUrl(path = "", paramMap = null, prefix = '') {
        if (path.indexOf('/') !== 0) {
            path = '/' + path;
        }
        let url = prefix + path;
        if (paramMap !== null) {
            if (Object.keys(paramMap).length > 0) {
                let paramUrl = '';
                for (const key in paramMap) {
                    if (paramUrl === '') {
                        paramUrl = '?';
                    }
                    else {
                        paramUrl += '&';
                    }
                    const value = paramMap[key];
                    if (value === undefined) {
                        paramUrl += key;
                    }
                    else {
                        // エンコードを行ってから設定する
                        const encodeValue = encodeURIComponent(value);
                        paramUrl += `${key}=${encodeValue}`;
                    }
                }
                url += paramUrl;
            }
        }
        return url;
    }
    /**
     * 現在、Urlからパラメーターのマップを作成して返す
     */
    function createParamMapForCurrentUrl() {
        return createParamMapForUrl(location.href);
    }
    UrlUtil.createParamMapForCurrentUrl = createParamMapForCurrentUrl;
    /**
     * Url から パラメータ のマップを作成して返す
     * @param url
     */
    function createParamMapForUrl(url) {
        const paramMap = {};
        const questionMarkIndex = url.indexOf('?');
        if (questionMarkIndex == -1) {
            return paramMap;
        }
        const paramText = url.substring(questionMarkIndex + 1);
        if (paramText.length == 0) {
            return paramMap;
        }
        const paramArray = paramText.split('&');
        for (const param of paramArray) {
            const paramSplit = param.split('=');
            const key = paramSplit[0];
            let value = undefined; // undefined のままだと key only
            if (paramSplit.length == 2) {
                // key, value
                value = paramSplit[1];
                try {
                    value = decodeURIComponent(value);
                }
                catch (e) {
                    // デコードできない場合は何もしない
                }
            }
            paramMap[key] = value;
        }
        return paramMap;
    }
    UrlUtil.createParamMapForUrl = createParamMapForUrl;
})(UrlUtil || (UrlUtil = {}));
